import React from 'react';
import { Box, Grid } from 'theme-ui';

const TwoColumnCheckoutBody = ({ firstColumn, secondColumn }) => (
  <Grid
    mt={3}
    mb={5}
    columns={[1, null, null, 2]}
    gap="100px"
    px={[3, 5]}
    sx={{
      position: 'relative',
    }}
  >
    <Box sx={{ position: 'relative' }}>{firstColumn}</Box>

    <Box
      className="vertical-divider"
      sx={{
        position: 'absolute',
        height: '100%',
        width: '1px',
        background: '#707070',
        left: '50%',
        display: ['none', null, null, 'block'],
      }}
    />

    <Box>{secondColumn}</Box>
  </Grid>
);

export default TwoColumnCheckoutBody;
